export const RM_HARDWARE_TICKET = "RM_HARDWARE_TICKET";
export const RM_HARDWARE_TICKET_FILTER = "RM_HARDWARE_TICKET_FILTER";